<ng-diagram-node-resize-adornment>
  <div
    class="group-node normal-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-content-id]="node()?.data?.pair.id"
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'pair'"
    [node]="node()"
  >
    <ng-diagram-port id="port-right" side="right" style="top: 30px" type="source" />

    <div class="group-node__header">
      <mat-icon class="ddc-content-icon">{{ icon() }}</mat-icon>
      <span class="group-node__title">{{ title() }}</span>
    </div>
    <div class="group-node__content">
      <div class="content-row">
        <ddc-country-flag [ddc_lng]="node()?.data?.pair.word_1.language"></ddc-country-flag>
        <span class="content-word">{{ node()?.data?.pair.word_1.word }}</span>
      </div>
      <div class="content-row">
        <ddc-country-flag [ddc_lng]="node()?.data?.pair.word_2.language"></ddc-country-flag>
        <span class="content-word">{{ node()?.data?.pair.word_2.word }}</span>
      </div>
    </div>
  </div>
</ng-diagram-node-resize-adornment>
